import { Container, PosedSection } from "components/layout";
import { PoseableBox, PoseableText } from "components/poseable";
import React, { PureComponent } from "react";
import resolveLink, { byUrl } from "utils/resolveLink";

import ButtonArrow from "components/icons/ButtonArrow";
import GatsbyLink from "gatsby-link";
import PropTypes from "prop-types";
import { Text } from "rebass";
import { biggest } from "components/typography/sizes";
import { fadeUp } from "components/poses";
import posed from "react-pose";
import styled from "styled-components";

const LinkContainer = styled(posed(PoseableBox)(fadeUp))`
  position: relative;
  text-align: center;
`;

const Link = styled(
  posed(PoseableText)({
    hoverable: true,
    focusable: true,
  })
)`
  position: relative;
  display: inline-block;
  margin: ${({ margin }) => (margin === undefined ? `0 auto` : margin)};
  text-decoration: none;
  flex: none;
  justify-self: flex-start;

  & a {
    color: inherit;
    font-family: inherit;
    text-decoration: none;
    position: relative;

    :focus,
    :active {
      outline: none;
    }
  }

  & svg {
    display: block;
    position: absolute;
    top: 0;
    right: 0;

    :nth-child(2) {
      top: 0.5em;
      right: 0.5em;
    }
  }
`;

export const BigLink = ({
  link,
  label,
  tabIndex = 0,
  focusHandler = null,
  ...rest
}) => (
  <Link
    textAlign="center"
    fontFamily="Druk"
    // onFocus={(e) => {
    //   if (focusHandler) {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     focusHandler();
    //     return false;
    //   }
    // }}
    tabIndex={tabIndex}
    onKeyDown={(e) => {
      if (e.which === 13) {
        e.target.querySelector("a").click();
      }
    }}
    // onClick={(e) => {
    //   e.target.querySelector("a").click();
    // }}
    {...rest}
  >
    <GatsbyLink
      to={
        typeof link === "string"
          ? byUrl(link)
          : link.url
          ? byUrl(link.url)
          : resolveLink(link.id)
      }
      title={link.title || label}
      tabIndex={tabIndex === 0 ? -1 : tabIndex}
    >
      <span tabIndex={-1}>{label.toUpperCase()}</span>
      <figure
        tabIndex={-1}
        style={{
          position: `absolute`,
          overflow: `hidden`,
          top: `calc(100% - 0.5em)`,
          right: `-0.1em`,
          width: `0.17em`,
          height: `0.17em`,
          transform: `translate3d(100%, -100%, 0)`,
        }}
      >
        <ButtonArrow width={`0.17em`} height={`0.17em`} />
      </figure>
    </GatsbyLink>
  </Link>
);

const PosedParagraph = posed(PoseableBox)(fadeUp);

export default class BigPageLink extends PureComponent {
  static propTypes = {
    theme: PropTypes.object,
    paragraphNode: PropTypes.shape({
      childMarkdownRemark: PropTypes.shape({
        html: PropTypes.string.isRequired,
      }).isRequired,
    }),
    linkLabel: PropTypes.string,
    link: PropTypes.string,
  };

  render() {
    const { paragraphNode, linkLabel, link, theme, big = null } = this.props;
    return (
      <PosedSection big={big}>
        <Container>
          {paragraphNode && (
            <PosedParagraph width={[1, 1, 3 / 5]} mx={`auto`} mb={[25, 30]}>
              <Text
                textAlign="center"
                is="aside"
                color={theme.textColor}
                fontFamily="Larish"
                fontWeight="semibold"
                fontSize={[18, 20, 24, 30]}
                lineHeight={1.35}
                dangerouslySetInnerHTML={{
                  __html: paragraphNode.childMarkdownRemark.html,
                }}
              />
            </PosedParagraph>
          )}
          <LinkContainer width={1} visibledelay={paragraphNode ? 300 : 0}>
            <BigLink
              link={link}
              label={linkLabel}
              color={theme.fgColor}
              fontSize={biggest}
            />
          </LinkContainer>
        </Container>
      </PosedSection>
    );
  }
}
